import EventBus from "../../common/EventBus";
import DatabaseService from "../../services/database.service";


export const handleMarkersDataReset = (setMarkers, markerPositionsRef) => {
    setMarkers([]);
    markerPositionsRef.current = [];
};

export const handleMarkersDataChart = (newMarkers, setMarkers, markerPositionsRef) => {
    setMarkers(newMarkers);
    markerPositionsRef.current = newMarkers;
};

export const addMarker = (xPosition, markerPositionsRef) => {
    const newPositions = [...markerPositionsRef.current, xPosition].sort((a, b) => a - b);
    markerPositionsRef.current = newPositions;
    EventBus.dispatch('handleMarkersData', newPositions);
};

export const removeMarker = (index, markerPositionsRef) => {
    const newPositions = markerPositionsRef.current.filter((_, idx) => idx !== index);
    markerPositionsRef.current = newPositions;
    EventBus.dispatch('handleMarkersData', newPositions);
};

export const trimContentData = async (start, end, contentDataRef, contentRunSelectedRef, markerPositionsRef, setNewContentData, mode) => {

    const dateStart = contentDataRef.current[start].date;
    const dateEnd = contentDataRef.current[end - 1].date;

    const trimmedData = contentDataRef.current.slice(start, end);
    const startIdxOffset = start;

    console.log("PerfsLineChartHelpers / trimContentData", dateStart, dateEnd);

    const newMarkers = markerPositionsRef.current
        .map(index => index - startIdxOffset)
        .filter(index => index >= 0 && index < trimmedData.length);

    DatabaseService.editPerfsRunLaps(contentRunSelectedRef.current.id, -1, newMarkers);

    if (mode == "before")
        DatabaseService.removePerfsPartialDatas(trimmedData[0].timestampRun, trimmedData[0].device_id, dateStart, 0);
    else if (mode == "after")
        DatabaseService.removePerfsPartialDatas(trimmedData[0].timestampRun, trimmedData[0].device_id, 0, dateEnd);

    // Update markers reference and state
    markerPositionsRef.current = newMarkers;
    EventBus.dispatch('handleMarkersData', newMarkers);
    setNewContentData(trimmedData);
};

export const createContextMenu = (event, chart, contentDataRef, contentRunSelectedRef, trimContentData, markerPositionsRef, setNewContentData) => {

    console.log("PerfsLineChartHelpers / createContextMenu");

    event.preventDefault();
    const { offsetX } = event;
    const xValue = chart.scales.x.getValueForPixel(offsetX);

    const menu = document.createElement('div');
    menu.className = 'context-menu';
    menu.style.left = `${event.pageX}px`;
    menu.style.top = `${event.pageY}px`;
    menu.style.display = 'block';

    const trimStart = document.createElement('button');
    trimStart.innerText = 'Delete before';
    trimStart.onclick = () => {
        if (window.confirm('Are you sure you want to delete the data from the start to this point?')) {
            trimContentData(xValue, contentDataRef.current.length, contentDataRef, contentRunSelectedRef, markerPositionsRef, setNewContentData, "before");
        }
        document.body.removeChild(menu);
    };

    const trimEnd = document.createElement('button');
    trimEnd.innerText = 'Delete after';
    trimEnd.onclick = () => {
        if (window.confirm('Are you sure you want to delete the data from this point to the end?')) {
            trimContentData(0, xValue, contentDataRef, contentRunSelectedRef, markerPositionsRef, setNewContentData, "after");
        }
        document.body.removeChild(menu);
    };

    menu.appendChild(trimStart);
    menu.appendChild(trimEnd);
    document.body.appendChild(menu);

    const removeMenu = () => {
        if (menu.parentNode) {
            menu.parentNode.removeChild(menu);
        }
        window.removeEventListener('click', removeMenu);
    };

    window.addEventListener('click', removeMenu);
};

export const updateAxises = (chartInstance, newVisibleDatasets, setVisibleAxises) => {

    // Update axis visibility based on active datasets
    let hasDataForY = false, hasDataForY2 = false, hasDataForY3 = false;
    chartInstance.data.datasets.forEach(dataset => {
        if (newVisibleDatasets.includes(dataset.label)) {
            if (!dataset.yAxisID || dataset.yAxisID === 'y') hasDataForY = true;
            if (dataset.yAxisID === 'y2') hasDataForY2 = true;
            if (dataset.yAxisID === 'y3') hasDataForY3 = true;
        }
    });

    chartInstance.options.scales.y.display = hasDataForY;
    chartInstance.options.scales.y2.display = hasDataForY2;
    chartInstance.options.scales.y3.display = hasDataForY3;

    return ({
        y: hasDataForY,
        y2: hasDataForY2,
        y3: hasDataForY3
    });
}

export const onLegendClick = (e, legendItem, setVisibleAxises, data) => {
    const chartInstance = e.chart;

    chartInstance.update();

    const index = legendItem.datasetIndex;
    const metaPrimary = chartInstance.getDatasetMeta(index);

    console.log("---")
    console.log("OLD / metaPrimary.hidden", metaPrimary.hidden, " / ci.data.datasets[index].hidden", chartInstance.data.datasets[index].hidden, " / metaPrimary.label", metaPrimary.label, " / data", data)

    // metaPrimary.hidden = metaPrimary.hidden === null ? !ci.data.datasets[index].hidden : null;

    // Toggle the visibility, ensuring hidden is always true or false
    // metaPrimary.hidden = !metaPrimary.hidden;
    if (chartInstance.data.datasets[index].hidden === true) {
        chartInstance.data.datasets[index].hidden = false;
        metaPrimary.hidden = null;
    }
    else {
        chartInstance.data.datasets[index].hidden = true;
        metaPrimary.hidden = true;
    }

    console.log("NEW / metaPrimary.hidden", metaPrimary.hidden, " / ci.data.datasets[index].hidden", chartInstance.data.datasets[index].hidden, " / metaPrimary.label", metaPrimary.label)

    // Handle secondary dataset
    const primaryLabel = chartInstance.data.datasets[index].label;
    const secondaryLabel = primaryLabel + '_sec';
    const secondaryDataset = chartInstance.data.datasets.find(d => d.label === secondaryLabel);

    if (secondaryDataset) {
        const metaSecondaryIndex = chartInstance.data.datasets.indexOf(secondaryDataset);
        const metaSecondary = chartInstance.getDatasetMeta(metaSecondaryIndex);
        metaSecondary.hidden = metaPrimary.hidden; // Sync with the primary dataset
        chartInstance.data.datasets[metaSecondaryIndex].hidden = metaPrimary.hidden;
    }

    // Update local storage
    const visibleDatasets = JSON.parse(localStorage.getItem('visibleDatasetsPerfs')) || [];
    let newVisibleDatasets;

    if (metaPrimary.hidden) {
        // Remove from visible datasets
        newVisibleDatasets = visibleDatasets.filter(label => label !== primaryLabel);
    } else {
        // Add to visible datasets and remove duplicates
        newVisibleDatasets = [...new Set([...visibleDatasets, primaryLabel])];
    }

    localStorage.setItem('visibleDatasetsPerfs', JSON.stringify(newVisibleDatasets));

    // setVisibleAxises(updateAxises(chartInstance, newVisibleDatasets));


    chartInstance.update();
};


// Function to merge and interpolate data with realigned timestamps
export const mergeAndInterpolateData = (data1, data2, fields) => {
    const timestamps = data1.map(item => item.date);
    const startTimeData1 = data1[0].date;
    const startTimeData2 = data2[0].date;
    const timeOffset = startTimeData2 - startTimeData1;

    // Adjust data2 timestamps to align with data1
    const adjustedData2 = data2.map(item => ({
        ...item,
        date: item.date - timeOffset
    }));

    const interpolate = (data, field, timestamp) => {
        const before = data.filter(item => item.date <= timestamp).slice(-1)[0];
        const after = data.filter(item => item.date >= timestamp)[0];
        if (before && after) {
            if (before.date === after.date) {
                return before[field];
            }
            return before[field] + (after[field] - before[field]) * ((timestamp - before.date) / (after.date - before.date));
        }
        return before ? before[field] : (after ? after[field] : null);
    };

    const alignedData2 = fields.reduce((acc, field) => {
        acc[field] = timestamps.map(timestamp => interpolate(adjustedData2, field, timestamp));
        return acc;
    }, {});

    const result = {
        timestamps,
        data1: fields.reduce((acc, field) => {
            acc[field] = data1.map(item => item[field]);
            return acc;
        }, {}),
        data2: alignedData2
    };

    return result;
};

// Calculate the distance between two GPS points
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const toRad = (value) => (value * Math.PI) / 180;
    const R = 6371e3; // Earth's radius in meters

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const lat1Rad = toRad(lat1);
    const lat2Rad = toRad(lat2);

    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1Rad) * Math.cos(lat2Rad);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
};

// Calculate cumulative distances for each point in the lap data
export const calculateCumulativeDistances = (lapData) => {
    let cumulativeDistances = [];
    let totalDistance = 0;

    for (let i = 0; i < lapData.length; i++) {
        if (i > 0) {
            const dist = calculateDistance(
                lapData[i - 1].positionGps_latitude, lapData[i - 1].positionGps_longitude,
                lapData[i].positionGps_latitude, lapData[i].positionGps_longitude
            );
            totalDistance += dist;
        }
        cumulativeDistances.push(totalDistance);
    }

    return cumulativeDistances;
};

// Calculate the time differences based on matching distances
export const calculateTimeDifferenceByDistance = (distancesLap1, distancesLap2, timesLap1, timesLap2) => {
    let timeDifferences = [];

    for (let i = 0; i < distancesLap1.length; i++) {
        let closestIndexLap2 = 0;
        let smallestDistanceDiff = Infinity;

        // Find the closest distance in Lap 2 for the current point in Lap 1
        for (let j = 0; j < distancesLap2.length; j++) {
            const distanceDiff = Math.abs(distancesLap1[i] - distancesLap2[j]);
            if (distanceDiff < smallestDistanceDiff) {
                smallestDistanceDiff = distanceDiff;
                closestIndexLap2 = j;
            }
        }

        // Calculate time difference
        if (timesLap1[i] && timesLap2[closestIndexLap2]) {
            const timeDiff = timesLap1[i] - timesLap2[closestIndexLap2];
            timeDifferences.push(timeDiff);
        }
    }

    return timeDifferences;
};

